module.exports = __webpack_public_path__ + "10c785407c1ad6822cbf04b2a93f171a.woff";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/torque-webfont/torque-bold.woff
// module id = 83
// module chunks = 0